import React, { useState, useCallback } from 'react';
import { string, shape, arrayOf } from 'prop-types';
import classnames from 'classnames';
import Characteristic from './Characteristic/Characteristic';
import './SecondaryCharacteristic.scss';

export default function SecondaryCharacteristic({
    characteristics,
    className,
}) {
    const [activeCharacteristicIndex, setActiveCharacteristicIndex] = useState(
        0,
    );

    const handleOpenCharacteristic = useCallback(
        (e, index) => {
            setActiveCharacteristicIndex(index);
        },
        [setActiveCharacteristicIndex],
    );

    const handleResetOpenedCharacteristic = useCallback(() => {
        if (activeCharacteristicIndex !== 0) {
            setActiveCharacteristicIndex(0);
        }
    }, [activeCharacteristicIndex, setActiveCharacteristicIndex]);

    const rootClassnames = classnames('secondary-characteristic', className);
    return (
        <div
            className={rootClassnames}
            onMouseLeave={handleResetOpenedCharacteristic}
        >
            {characteristics.map((characteristic, index) => (
                <Characteristic
                    key={characteristic.icon}
                    active={activeCharacteristicIndex === index}
                    icon={characteristic.icon}
                    claim={characteristic.claim}
                    index={index}
                    onHover={handleOpenCharacteristic}
                />
            ))}
        </div>
    );
}

SecondaryCharacteristic.propTypes = {
    className: string,
    characteristics: arrayOf(shape({ icon: string, claim: string })).isRequired,
};

SecondaryCharacteristic.defaultProps = {
    className: null,
};
